/* Import Estilo */
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/* Import Bibliotecas */
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CurrencyInput from 'react-currency-input-field';

/* Import Componentes */
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';
import ModalDetalheProduto from '../../../../components/ModalDetalheProduto';

/* Import Requisição API */
import api from '../../../../api';
import { formatadorCNPJ, formatadorCPF, formatadorNumeroCelular, formatarCpfCnpj, formatarPrecoReal, construirDescricaoVariacao } from '../../../../utils/Validadores';
import { formatarPrecoUnitario } from '../../../../utils/precoUnitario';
import { buscaInteligente } from '../../../../utils/buscaInteligente';

export default function EditarPedido() {
    const location = useLocation();
    const id_pedido = location.state?.id || sessionStorage.getItem('editarPedidoId');
    const navigate = useNavigate();

    const [clientes, setClientes] = useState([]);
    const [usuario_id, setIdUsuario] = useState();
    const [pesquisa, setPesquisa] = useState('');
    const [pesquisaProduto, setPesquisaProduto] = useState('');
    const [pesquisaProdutosCarrinho, setPesquisaProdutosCarrinho] = useState("");
    const [mostrarLista, setMostrarLista] = useState(true);

    const [statusPagamento, setStatusPagamento] = useState(true);

    // dados do cliente
    const [idCliente, setIdCliente] = useState(null);
    const [nome, setNome] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");
    const [sexo, setSexo] = useState("");
    const [nivel, setNivel] = useState("");
    const [enderecos, setEnderecos] = useState([]);
    const [enderecoSelecionado, setEnderecoSelecionado] = useState(null);

    // carrinho e produtos
    const [produtos, setProdutos] = useState([]); // se precisar mostrar lista de produtos
    const [carrinho, setCarrinho] = useState([]);

    // pagamento e totais
    const [desconto, setDesconto] = useState(0);
    const [frete, setFrete] = useState(0);
    const [metodoPagamento, setMetodoPagamento] = useState("");
    const [status, setStatus] = useState("");
    const [observacao, setObservacao] = useState("");
    const [dataPagamento, setDataPagamento] = useState("");

    const [clienteSelecionado, setClienteSelecionado] = useState(false);

    const carrinhoVazio = carrinho.length === 0;

    /* Estado - Modal Detalhe Produto */
    const [produtoDetalhe, setProdutoDetalhe] = useState(null);

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    /* Controle de saída da página */
    const [navegacaoPermitida, setNavegacaoPermitida] = useState(false);
    const CaixaDeDialogoSair = useRef(null);
    const salvandoRef = useRef(false);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
        CaixaDeDialogoSair.current = document.getElementById("CaixaDeDialogoSair");
    }, []);

    /* Persistir id do pedido para sobreviver a recarregamento */
    useEffect(() => {
        if (id_pedido) {
            sessionStorage.setItem('editarPedidoId', id_pedido);
        }
        return () => {
            if (navegacaoPermitida) {
                sessionStorage.removeItem('editarPedidoId');
            }
        };
    }, [id_pedido, navegacaoPermitida]);

    /* Bloqueio de navegação (popstate + beforeunload) */
    const temDadosPedido = idCliente || carrinho.length > 0;
    const navegacaoPermitidaRef = useRef(false);

    // Manter ref sincronizada com state
    useEffect(() => {
        navegacaoPermitidaRef.current = navegacaoPermitida;
    }, [navegacaoPermitida]);

    const confirmarSaida = () => {
        CaixaDeDialogoSair.current?.close();
        setNavegacaoPermitida(true);
        navegacaoPermitidaRef.current = true;
        sessionStorage.removeItem('editarPedidoId');
        // Volta 2x: 1 para desfazer o pushState extra, 1 para sair da página
        window.history.go(-2);
    };

    const cancelarSaida = () => {
        CaixaDeDialogoSair.current?.close();
    };

    useEffect(() => {
        if (!temDadosPedido || salvandoRef.current) return;

        // Empurra estado extra para interceptar o botão voltar
        window.history.pushState({ bloqueioSaida: true }, '');

        const handlePopState = (e) => {
            if (navegacaoPermitidaRef.current || salvandoRef.current) return;

            // Re-empurra para manter na página
            window.history.pushState({ bloqueioSaida: true }, '');
            if (CaixaDeDialogoSair.current) {
                CaixaDeDialogoSair.current.showModal();
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [temDadosPedido]);

    /* Aviso ao recarregar / fechar aba */
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (temDadosPedido) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [temDadosPedido]);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    const clientesFiltrados = clientes.filter((cliente) =>
        buscaInteligente(pesquisa, [cliente.nome, cliente.cpf_cnpj, cliente.email])
    );

    useEffect(() => {
        const fetchClientes = async () => {
            try {
                const response = await api.get('/listarclientescomendereco');
                console.log(response);
                setClientes(response.data.clientes || []);
            } catch (error) {
                console.error('Erro ao carregar clientes:', error);
            }
        };
        if (usuario_id) fetchClientes();
    }, [usuario_id]);

    const produtosFiltrados = produtos.filter((produto) => {
        const descricaoVariacao = construirDescricaoVariacao(produto);
        return buscaInteligente(pesquisaProduto, [
            produto.nome, descricaoVariacao, produto.descricao,
            produto.cor, produto.tamanho,
            produto.material, produto.tipo, produto.sku,
            produto.codigo_barras, produto.marca
        ]);
    }).sort((a, b) => a.nome.localeCompare(b.nome));

    const produtosCarrinhoFiltrados = carrinho.filter((item) => {
        return buscaInteligente(pesquisaProdutosCarrinho, [
            item.nome_produto, item.nome,
            item.cor, item.tamanho,
            item.material, item.tipo,
            item.sku, item.codigo_barras
        ]);
    }).sort((a, b) => a.nome_produto.localeCompare(b.nome_produto));

    useEffect(() => {
        const fetchProdutos = async () => {
            try {
                const response = await api.get('/listarprodutosAdm');
                if (response.data.success) {
                    console.log(response.data.produtos);
                    const produtosAgrupados = response.data.produtos || [];
                    
                    const variacoesFlatten = produtosAgrupados.flatMap(prod => {
                        const variacoes = Array.isArray(prod.variacoes) ? prod.variacoes : [];
                        return variacoes.map(v => ({
                            id_produto: prod.id,
                            nome: prod.nome,
                            descricao: prod.descricao || '',
                            categoria: prod.categoria || '',
                            marca: prod.marca || '',
                            codigo_barras: prod.codigo_barras || '',
                            id_variacao: v.id,
                            tamanho: v.tamanho,
                            cor: v.cor,
                            tipo: v.tipo,
                            material: v.material,
                            preco_varejo: Number(v.preco_varejo) || 0,
                            preco_atacado: Number(v.preco_atacado) || 0,
                            estoque: Number(v.estoque) || 0,
                            sku: v.sku,
                            unidades_por_pacote: Number(v.unidades_por_pacote) || 1,
                            imagens: Array.isArray(v.imagens) ? v.imagens : [],
                        }));
                    });

                    setProdutos(variacoesFlatten);
                } else {
                    console.warn(response.data.message);
                }
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
            }
        };
        fetchProdutos();
    }, []);

    const cadastroCliente = () => navigate('/menu/clientes/cadastrocliente');

    const selecionarProduto = (variacao) => {
        console.log('Variação selecionada:', variacao);

        // Determinar o preço baseado no nível do cliente
        const precoSelecionado = nivel === 'Atacadista' 
            ? (variacao.preco_atacado ?? 0)
            : (variacao.preco_varejo ?? 0);

        setCarrinho(prev => {
            const itemExistente = prev.find(i => i.id_variacao === variacao.id_variacao);
            if (itemExistente) {
                return prev.map(i =>
                    i.id_variacao === variacao.id_variacao
                        ? { ...i, quantidade: i.quantidade + 1 }
                        : i
                );
            } else {
                const imagem = variacao.imagens?.[0] ?? null;
                const descricaoVariacao = construirDescricaoVariacao(variacao);
                const nomeProduto = variacao.nome;

                return [
                    ...prev,
                    {
                        id_produto: variacao.id_produto,
                        id_variacao: variacao.id_variacao,
                        nome_produto: nomeProduto,
                        nome: descricaoVariacao,
                        tamanho: variacao.tamanho,
                        cor: variacao.cor,
                        material: variacao.material,
                        tipo: variacao.tipo,
                        unidades_por_pacote: variacao.unidades_por_pacote ?? 1,
                        preco: precoSelecionado,
                        preco_varejo: variacao.preco_varejo,
                        preco_atacado: variacao.preco_atacado,
                        quantidade: 1,
                        imagem,
                    }
                ];
            }
        });
    };



    const alterarQuantidade = (id, delta) => {
        setCarrinho((prev) => {
            return prev
                .map(item => item.id_variacao === id
                    ? { ...item, quantidade: item.quantidade + delta }
                    : item
                )
                .filter(item => item.quantidade > 0);
        });
    };

    const alterarQuantidadeDireto = (idVariacao, novaQtd) => {
        const quantidade = parseInt(novaQtd, 10);
        if (!isNaN(quantidade) && quantidade >= 0) {
            setCarrinho((prev) =>
                prev.map(item =>
                    item.id_variacao === idVariacao
                        ? { ...item, quantidade: quantidade }
                        : item
                )
            );
        }
    };

    const buscarCliente = async (id) => {
        try {
            const response = await api.get(`/clientes/${id}`);
            const cliente = response.data.cliente;

            if (!cliente) {
                console.error("Cliente não encontrado.");
                return;
            }

            const cpfCnpjFormatado =
                cliente.cpf_cnpj.length === 11
                    ? formatadorCPF(cliente.cpf_cnpj)
                    : formatadorCNPJ(cliente.cpf_cnpj);

            setEnderecos(cliente.enderecos || []);
            setEnderecoSelecionado(
                cliente.enderecos && cliente.enderecos.length > 0
                    ? 0
                    : null
            );
            setNome(cliente.nome);
            setCpfCnpj(cpfCnpjFormatado);
            setEmail(cliente.email);
            setNivel(cliente.nivel_acesso);
            setCelular(formatadorNumeroCelular(cliente.celular));
            setIdCliente(cliente.id);
            setDataNascimento(
                cliente.data_nascimento
                    ? new Date(cliente.data_nascimento).toLocaleDateString("pt-BR")
                    : ""
            );
            setSexo(cliente.sexo);
            setMostrarLista(false);
        } catch (error) {
            console.error("Erro ao carregar dados do cliente:", error);
        }
    };

    useEffect(() => {
        const fetchPedido = async () => {
            try {
                const { data } = await api.get(`/pedidos/${id_pedido}`);
                if (!data.success) {
                    setTexto(data.message || 'Nao foi possivel carregar os dados do pedido.');
                    abrirModalAviso();
                    return;
                }

                const { pedido, itens } = data;

                // Produtos no carrinho
                setCarrinho(
                    itens.map((i) => {
                        // Fazer parse de "Nome - Atributos" 
                        const partes = i.descricao_produto.split(' - ');
                        const nome_produto = partes[0];
                        const nome = partes.slice(1).join(' - ');
                        return {
                            id_produto: i.id_produto,
                            id_variacao: i.id_variacao,
                            quantidade: i.quantidade,
                            preco: i.preco,
                            preco_varejo: i.preco,
                            nome_produto: nome_produto,
                            nome: nome,
                            imagem: i.url_img
                        };
                    })
                );

                // Dados do pedido
                setDesconto(pedido.desconto);
                setFrete(pedido.frete);
                setMetodoPagamento(pedido.metodo_pagamento || "");
                setStatusPagamento(pedido.status_pagamento);
                setObservacao(pedido.observacao || "");
                setDataPagamento(
                    pedido.data_pagamento ? pedido.data_pagamento.slice(0, 10) : ""
                );

                // Buscar cliente
                const respCliente = await api.get(`/clientes/${pedido.cliente.id}`);
                const c = respCliente.data.cliente;

                setIdCliente(c.id);
                setNome(c.nome);
                setCpfCnpj(c.cpf_cnpj);
                setEmail(c.email);
                setCelular(c.celular);
                setDataNascimento(
                    c.data_nascimento
                        ? new Date(c.data_nascimento).toLocaleDateString("pt-BR")
                        : ""
                );
                setSexo(c.sexo);
                setNivel(c.nivel_acesso);

                setEnderecos(c.enderecos || []);

                if (c.enderecos && c.enderecos.length > 0 && pedido.endereco_id) {
                    const idxEndereco = c.enderecos.findIndex(
                        (end) => end.id === pedido.endereco_id
                    );
                    setEnderecoSelecionado(idxEndereco >= 0 ? idxEndereco : 0);
                } else {
                    setEnderecoSelecionado(null);
                }

                setMostrarLista(false);

            } catch (err) {
                console.error("Erro ao carregar edição:", err);
                setTexto('Nao foi possivel carregar os dados do pedido.');
                abrirModalAviso();
            }
        };

        if (id_pedido) {
            fetchPedido();
        }
    }, [id_pedido]);


    const salvar = async () => {
        if (!idCliente || carrinho.length === 0) {
            setTexto('Selecione um cliente e adicione ao menos um produto ao carrinho.');
            abrirModalAviso();
            return;
        }

        if (enderecoSelecionado === null) {
            setTexto('Por favor, selecione um endereço de entrega.');
            abrirModalAviso();
            return;
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);

        const end = enderecos[enderecoSelecionado];

        const pedido = {
            itens: carrinho.map(item => ({
                id_produto: item.id_produto,
                quantidade: item.quantidade,
                preco: item.preco,
                descricao_produto: `${item.nome_produto} - ${item.nome}`,
                url_img: item.imagem
            })),
            desconto: desconto || 0,
            frete: 0,
            metodo_pagamento: metodoPagamento || null, // null if not selected
            observacao: observacao,
            status_pagamento: statusPagamento || 'Pendente',
            data_pagamento: dataPagamento || null, // null if not selected
        };

        try {
            const { data } = await api.put(`/pedidos/${id_pedido}`, {
                pedido,
                clienteId: idCliente,
                usuarioId: usuario_id,
                enderecoId: end.id
            });

            if (data.success) {
                setTexto('Pedido atualizado com sucesso!');
                abrirModalAviso();
                setNavegacaoPermitida(true);
                sessionStorage.removeItem('editarPedidoId');
                navigate("/menu/pedidos/visualizarpedido", { state: { id : id_pedido } });
            } else {
                setTexto(data.message ? `Erro: ${data.message}` : 'Erro ao atualizar pedido.');
                abrirModalAviso();
            }
        } catch (err) {
            console.error("Erro ao salvar edição:", err);
            setTexto('Erro interno ao atualizar pedido.');
            abrirModalAviso();
        } finally {
            setLoading(false);
        }
    };

    // Auto-save quando há mudanças importantes
    useEffect(() => {
        const performAutoSave = async () => {
            // Só tenta salvar se houver CLIENTE SELECIONADO E PRODUTO NO CARRINHO
            if (!idCliente || carrinho.length === 0 || !id_pedido) {
                return;
            }

            // Se não houver endereço selecionado, não salva
            if (enderecoSelecionado === null) {
                return;
            }

            const end = enderecos[enderecoSelecionado];

            const pedido = {
                itens: carrinho.map(item => ({
                    id_produto: item.id_produto ?? null,
                    id_variacao: item.id_variacao ?? null,
                    quantidade: item.quantidade,
                    preco: item.preco,
                    descricao_produto: `${item.nome_produto} - ${item.nome}`,
                    url_img: item.imagem
                })),
                desconto: desconto || 0,
                frete: frete || 0,
                metodo_pagamento: metodoPagamento || null, // null if not selected
                status: status,
                observacao: observacao,
                status_pagamento: statusPagamento || 'Pendente',
                data_pagamento: dataPagamento || null, // null if not selected
            };

            try {
                const response = await api.put(`/pedidos/${id_pedido}`, {
                    pedido,
                    clienteId: idCliente,
                    usuarioId: usuario_id,
                    enderecoId: end.id
                });

                if (response.data.success) {
                    console.log('Pedido salvo automaticamente:', id_pedido);
                }
            } catch (error) {
                console.error("Erro ao auto-salvar pedido:", error);
                // Não mostra erro para o usuário pois é auto-save silencioso
            }
        };

        // Definir novo timeout para salvar após 3 segundos de inatividade
        const timeout = setTimeout(() => {
            performAutoSave();
        }, 3000); // 3 segundos

        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [idCliente, carrinho, desconto, frete, metodoPagamento, status, dataPagamento, observacao, enderecoSelecionado, usuario_id, enderecos, id_pedido, statusPagamento]);

    return (
        <section className='container-principal-pedido'>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaDeDialogoSair'>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>Tem certeza que deseja sair? Os dados não salvos serão perdidos.</p>
                        <div className='bnts-decisao'>
                            <button className='bnt-sim' onClick={confirmarSaida}>Sim</button>
                            <button className='bnt-nao' onClick={cancelarSaida}>Não</button>
                        </div>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />

            <main className='main-cadastroPedido'>
                <MenuLateral />

                <section className='conteudo-cadastroPedido'>
                    <div className='titulo-cadastroPedido'>
                        <h1>
                            <span>Pedidos</span> &gt; Editar Pedido
                        </h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <>
                    <div className='perfil-cadastro-cadastroPedido'>
                        <div className='dados-cliente'>
                            <div className='cabecalho-cliente'>
                                <h2>Selecione o Cliente</h2>
                            </div>
                            {mostrarLista && (
                                <div className='conteudo-cliente'>
                                    <div className='barraDePesquisa-e-cadastroPedido-container'>
                                        <div className='barraDePesquisa-clientes'>
                                            <svg
                                                width="31"
                                                height="31"
                                                viewBox="0 0 31 31"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z"
                                                    stroke="#131C46"
                                                    strokeWidth="4.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <input
                                                type='text'
                                                placeholder='Pesquise o cliente pelo: Nome'
                                                value={pesquisa}
                                                onChange={(e) => setPesquisa(e.target.value)}
                                            />
                                        </div>
                                        <button
                                            className='bnt-cadastrarClientes'
                                            onClick={cadastroCliente}
                                        >
                                            + Cadastrar Cliente
                                        </button>
                                    </div>
                                    <div className='tabela-clientes'>
                                        {clientesFiltrados.length === 0 ? (
                                            <p className='nenhum-cliente'>Nenhum cliente encontrado =(</p>
                                        ) : (
                                            <table className='conteudo-tabela'>
                                                <tbody>
                                                    {clientesFiltrados.map((cliente) => (
                                                        <tr key={cliente.id} className='conteudo'>
                                                            <td className='primeiro'>{cliente.nome}</td>
                                                            <td>{formatadorNumeroCelular(cliente.celular)}</td>
                                                            <td>{formatarCpfCnpj(cliente.cpf_cnpj)}</td>
                                                            <td className='final'>
                                                                <button className='select-client' onClick={() => buscarCliente(cliente.id)}>Selecionar Cliente</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            )}
                            {!mostrarLista && (
                                <div className='dados-cliente-selecionado'>
                                    <div className="detalhes-cliente">
                                        <div className="dados-DescricaoCliente">
                                            <div className="dadoDuplo">
                                                <div className="dado">
                                                    <strong>Nome:</strong>
                                                    <p>{nome}</p>
                                                </div>
                                                <div className="dado">
                                                    <strong>CPF/CNPJ:</strong>
                                                    <p>{cpfCnpj}</p>
                                                </div>
                                            </div>
                                            <div className="dadoDuplo">
                                                <div className="dado">
                                                    <strong>Email:</strong>
                                                    <p>{email}</p>
                                                </div>
                                                <div className="dado">
                                                    <strong>Celular:</strong>
                                                    <p>{celular}</p>
                                                </div>
                                            </div>
                                            <div className="dadoDuplo">
                                                <div className="dado">
                                                    <strong>Data de nascimento:</strong>
                                                    <p>{dataNascimento}</p>
                                                </div>
                                                <div className="dado">
                                                    <strong>Sexo:</strong>
                                                    <p>{sexo}</p>
                                                </div>
                                                <div className="dado">
                                                    <strong>Perfil:</strong>
                                                    <p>{nivel}</p>
                                                </div>
                                            </div>
                                            <div className="selecionar-endereco">
                                                <h3><svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 22.1425V5.5C26.5 4.57174 26.1313 3.6815 25.4749 3.02513C24.8185 2.36875 23.9283 2 23 2H5.5C4.57174 2 3.6815 2.36875 3.02513 3.02513C2.36875 3.6815 2 4.57174 2 5.5V21.25C2 21.7141 2.18437 22.1592 2.51256 22.4874C2.84075 22.8156 3.28587 23 3.75 23H4.9925C5.33363 22.2211 5.89434 21.5585 6.60607 21.0932C7.31779 20.6279 8.14968 20.3802 9 20.3802C9.85032 20.3802 10.6822 20.6279 11.3939 21.0932C12.1057 21.5585 12.6664 22.2211 13.0075 23H25.9925C26.1208 22.6908 26.29 22.405 26.5 22.1425ZM26.5 22.1425C26.9548 21.5256 27.5642 21.0396 28.2669 20.7335C28.9695 20.4273 29.7404 20.3119 30.5019 20.3989C31.2633 20.4859 31.9884 20.7721 32.6039 21.2288C33.2194 21.6855 33.7035 22.2964 34.0075 23H37V17.9425C37.0007 16.6726 36.6558 15.4264 36.0025 14.3375L33.85 10.75L32.2575 8.1075C32.1026 7.84626 31.8824 7.62983 31.6185 7.47949C31.3547 7.32914 31.0562 7.25005 30.7525 7.25H26.5V22.1425Z" stroke="#131C46" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /><path d="M17.75 14.25H9M17.75 9H9M13.375 24.75C13.3758 25.4008 13.2313 26.0436 12.9522 26.6316C12.673 27.2195 12.2662 27.7377 11.7614 28.1485C11.2566 28.5593 10.6665 28.8523 10.0341 29.0062C9.40176 29.16 8.74301 29.1708 8.10592 29.0378C7.46882 28.9048 6.86942 28.6313 6.35141 28.2373C5.83339 27.8433 5.40981 27.3387 5.11153 26.7602C4.81325 26.1818 4.64778 25.5441 4.62719 24.8936C4.6066 24.2431 4.7314 23.5962 4.9925 23C5.39535 22.0802 6.10238 21.3269 6.9949 20.8667C7.88742 20.4064 8.91109 20.2673 9.89409 20.4725C10.8771 20.6777 11.7596 21.2148 12.3934 21.9937C13.0272 22.7726 13.3738 23.7458 13.375 24.75ZM34.375 24.75C34.3758 25.4008 34.2313 26.0436 33.9522 26.6316C33.673 27.2195 33.2662 27.7377 32.7614 28.1485C32.2566 28.5593 31.6665 28.8523 31.0341 29.0062C30.4018 29.16 29.743 29.1708 29.1059 29.0378C28.4688 28.9048 27.8694 28.6313 27.3514 28.2373C26.8334 27.8433 26.4098 27.3387 26.1115 26.7602C25.8132 26.1818 25.6478 25.5441 25.6272 24.8936C25.6066 24.2431 25.7314 23.5962 25.9925 23C26.1208 22.6908 26.29 22.405 26.5 22.1425C26.9548 21.5256 27.5642 21.0396 28.2669 20.7335C28.9695 20.4273 29.7404 20.3119 30.5019 20.3989C31.2633 20.4859 31.9884 20.7721 32.6039 21.2288C33.2194 21.6855 33.7035 22.2964 34.0075 23C34.2525 23.5512 34.3785 24.148 34.375 24.75Z" stroke="#131C46" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /></svg>Selecione o endereço de entrega:</h3>
                                                <div className="caixas-endereco">
                                                    {enderecos.length === 0 ? (
                                                        <p className='nenhum-endereco'>Não há endereços cadastrados.</p>
                                                    ) : (
                                                        enderecos.map((end, idx) => (
                                                            <label
                                                                key={idx}
                                                                className={`endereco-item ${enderecoSelecionado === idx ? 'selecionado' : ''}`}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    name="endereco"
                                                                    checked={enderecoSelecionado === idx}
                                                                    onChange={() => setEnderecoSelecionado(idx)}
                                                                />
                                                                <p>
                                                                    <span>Endereço {idx}</span><br />
                                                                    {end.logradouro}, {end.numero}
                                                                    {end.complemento && `, ${end.complemento}`}<br />
                                                                    {end.bairro}, {end.cidade}/{end.estado}<br />
                                                                    CEP {end.cep}
                                                                </p>
                                                                {enderecoSelecionado === idx && <span className="icone-check"><svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 22.1425V5.5C26.5 4.57174 26.1313 3.6815 25.4749 3.02513C24.8185 2.36875 23.9283 2 23 2H5.5C4.57174 2 3.6815 2.36875 3.02513 3.02513C2.36875 3.6815 2 4.57174 2 5.5V21.25C2 21.7141 2.18437 22.1592 2.51256 22.4874C2.84075 22.8156 3.28587 23 3.75 23H4.9925C5.33363 22.2211 5.89434 21.5585 6.60607 21.0932C7.31779 20.6279 8.14968 20.3802 9 20.3802C9.85032 20.3802 10.6822 20.6279 11.3939 21.0932C12.1057 21.5585 12.6664 22.2211 13.0075 23H25.9925C26.1208 22.6908 26.29 22.405 26.5 22.1425ZM26.5 22.1425C26.9548 21.5256 27.5642 21.0396 28.2669 20.7335C28.9695 20.4273 29.7404 20.3119 30.5019 20.3989C31.2633 20.4859 31.9884 20.7721 32.6039 21.2288C33.2194 21.6855 33.7035 22.2964 34.0075 23H37V17.9425C37.0007 16.6726 36.6558 15.4264 36.0025 14.3375L33.85 10.75L32.2575 8.1075C32.1026 7.84626 31.8824 7.62983 31.6185 7.47949C31.3547 7.32914 31.0562 7.25005 30.7525 7.25H26.5V22.1425Z" stroke="#131C46" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /><path d="M20.207 6.5C20.5323 6.50004 20.8514 6.61919 21.0928 6.8418C21.3354 7.06569 21.4805 7.37842 21.4805 7.71387C21.4804 8.04926 21.3354 8.3621 21.0928 8.58594L12.8838 16.1582C12.3897 16.614 11.6054 16.614 11.1113 16.1582L7.86816 13.166C7.74831 13.0554 7.65034 12.9224 7.58301 12.7725C7.51559 12.6223 7.48047 12.4592 7.48047 12.2939C7.48057 11.9586 7.62552 11.6457 7.86816 11.4219C8.10947 11.1994 8.42873 11.0811 8.75391 11.0811C9.07906 11.0811 9.39832 11.1995 9.63965 11.4219L11.9932 13.5928L19.3213 6.8418C19.5626 6.61921 19.8817 6.5 20.207 6.5Z" fill="#28A745" stroke="#28A745" /><path d="M13.375 24.7503C13.3758 25.4012 13.2313 26.044 12.9522 26.6319C12.673 27.2198 12.2662 27.7381 11.7614 28.1489C11.2566 28.5597 10.6665 28.8527 10.0341 29.0065C9.40176 29.1604 8.74301 29.1712 8.10592 29.0382C7.46882 28.9052 6.86942 28.6317 6.35141 28.2377C5.83339 27.8437 5.40981 27.339 5.11153 26.7606C4.81325 26.1821 4.64778 25.5444 4.62719 24.8939C4.6066 24.2434 4.7314 23.5965 4.9925 23.0003C5.39535 22.0805 6.10238 21.3273 6.9949 20.867C7.88742 20.4068 8.91109 20.2676 9.89409 20.4728C10.8771 20.678 11.7596 21.2152 12.3934 21.9941C13.0272 22.7729 13.3738 23.7462 13.375 24.7503ZM34.375 24.7503C34.3758 25.4012 34.2313 26.044 33.9522 26.6319C33.673 27.2198 33.2662 27.7381 32.7614 28.1489C32.2566 28.5597 31.6665 28.8527 31.0341 29.0065C30.4018 29.1604 29.743 29.1712 29.1059 29.0382C28.4688 28.9052 27.8694 28.6317 27.3514 28.2377C26.8334 27.8437 26.4098 27.339 26.1115 26.7606C25.8132 26.1821 25.6478 25.5444 25.6272 24.8939C25.6066 24.2434 25.7314 23.5965 25.9925 23.0003C26.1208 22.6912 26.29 22.4053 26.5 22.1428C26.9548 21.526 27.5642 21.0399 28.2669 20.7338C28.9695 20.4277 29.7404 20.3123 30.5019 20.3992C31.2633 20.4862 31.9884 20.7725 32.6039 21.2292C33.2194 21.6859 33.7035 22.2968 34.0075 23.0003C34.2525 23.5516 34.3785 24.1483 34.375 24.7503Z" stroke="#131C46" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /></svg></span>}
                                                            </label>
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                            <button
                                                className='btn-voltar-lista'
                                                onClick={() => setMostrarLista(true)}
                                            >
                                                Selecionar outro cliente
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {!mostrarLista && (
                        <div className='dados-produto'>
                            <div className='cabecalho-produto'>
                                <h2>Selecione os Produtos</h2>
                            </div>
                            <div className='conteudo-produto'>
                                <div className='produtos-container'>
                                    <div className='itens-carrinho'>
                                        <div className='titulo-produto'>
                                            <h2><svg width="40" height="50" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35 10H30C30 4.475 25.525 0 20 0C14.475 0 10 4.475 10 10H5C2.25 10 0 12.25 0 15V45C0 47.75 2.25 50 5 50H35C37.75 50 40 47.75 40 45V15C40 12.25 37.75 10 35 10ZM20 5C22.75 5 25 7.25 25 10H15C15 7.25 17.25 5 20 5ZM35 45H5V15H10V20C10 21.375 11.125 22.5 12.5 22.5C13.875 22.5 15 21.375 15 20V15H25V20C25 21.375 26.125 22.5 27.5 22.5C28.875 22.5 30 21.375 30 20V15H35V45Z" fill="#131C46" /></svg>Produto</h2>
                                        </div>
                                        <div className='barraDePesquisa-e-produto-container'>
                                            <div className='barraDePesquisa-produtos'>
                                                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z" stroke="#131C46" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                                <input
                                                    type='text'
                                                    placeholder='Pesquise o produto pelo: Nome'
                                                    value={pesquisaProduto}
                                                    onChange={(e) => setPesquisaProduto(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='produtos'>
                                            {produtosFiltrados.length === 0 ? (
                                                <p className='nenhum-produto'>Nenhum produto encontrado =(</p>
                                            ) : (
                                                produtosFiltrados.map((produto) => {
                                                    const produtoNoCarrinho = carrinho.some(p => p.id_variacao === produto.id_variacao);
                                                    const descricaoVariacao = construirDescricaoVariacao(produto);
                                                    return (
                                                        <div key={produto.id_variacao} className='produto-card' onClick={() => selecionarProduto(produto)}>
                                                            <div className='micro-descricao' onClick={(e) => { e.stopPropagation(); setProdutoDetalhe(produto); }} style={{cursor: 'pointer'}}>
                                                                <div className='imagem-produto'>
                                                                    {produto.imagens && produto.imagens.length > 0 ? (
                                                                        <img
                                                                            src={produto.imagens[0]}
                                                                            alt={produto.nome}
                                                                            className='produto-imagem'
                                                                        />
                                                                    ) : (
                                                                        <div className='produto-sem-imagem'>Sem Imagem</div>
                                                                    )}
                                                                </div>
                                                                <div className='detalhes-produtos'>
                                                                    <h3 className='produto-nome'>
                                                                        {produto.nome}
                                                                    </h3>
                                                                    {descricaoVariacao && <p style={{opacity: 0.6, fontSize: '0.85em', margin: '2px 0', fontWeight: 500}}>{descricaoVariacao}</p>}
                                                                    {produto.unidades_por_pacote > 1 ? (
                                                                        <>
                                                                            <p className='produto-preco'><strong>Unit.:</strong> {produto.unidades_por_pacote} | <strong>Preço:</strong> {formatarPrecoReal(nivel === 'Atacadista' ? produto.preco_atacado : produto.preco_varejo)} | <strong>Preço/Un.:</strong> {formatarPrecoUnitario(nivel === 'Atacadista' ? produto.preco_atacado : produto.preco_varejo, produto.unidades_por_pacote)}</p>
                                                                        </>
                                                                    ) : (
                                                                        <p className='produto-preco'><strong>Preço:</strong> {formatarPrecoReal(nivel === 'Atacadista' ? produto.preco_atacado : produto.preco_varejo)}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <button
                                                                className={`btn-selecionar-produto ${produtoNoCarrinho ? 'selecionado' : ''}`}
                                                            >
                                                                {produtoNoCarrinho ? (
                                                                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M4.95783 7.625L12.0203 0.5625C12.187 0.395833 12.3814 0.3125 12.6037 0.3125C12.8259 0.3125 13.0203 0.395833 13.187 0.5625C13.3537 0.729167 13.437 0.927222 13.437 1.15667C13.437 1.38611 13.3537 1.58389 13.187 1.75L5.54117 9.41667C5.3745 9.58333 5.18005 9.66667 4.95783 9.66667C4.73561 9.66667 4.54117 9.58333 4.3745 9.41667L0.791166 5.83333C0.624499 5.66667 0.544499 5.46889 0.551166 5.24C0.557833 5.01111 0.644777 4.81306 0.811999 4.64583C0.979221 4.47861 1.17728 4.39528 1.40617 4.39583C1.63505 4.39639 1.83283 4.47972 1.9995 4.64583L4.95783 7.625Z" fill="white" />
                                                                    </svg>
                                                                ) : (
                                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" />
                                                                    </svg>
                                                                )}
                                                            </button>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="carrinho-produtos">
                                    <div className='dados-carrinho'>
                                        <div className='titulo-carrinho'>
                                            <h2><svg width="45" height="50" viewBox="0 0 45 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.9934 32.4618C44.9878 30.9629 44.5323 29.5 43.6856 28.2625C42.8389 27.025 41.6401 26.0696 40.2441 25.52L44.9184 8.04056C45.016 7.6683 45.0262 7.27853 44.9482 6.90169C44.8701 6.52484 44.7059 6.17111 44.4684 5.86812C44.2256 5.58422 43.9222 5.35833 43.5804 5.20707C43.2387 5.05582 42.8673 4.98306 42.4937 4.99415H8.24878L7.4239 1.84785C7.28049 1.31575 6.96491 0.84599 6.52635 0.51176C6.08779 0.177529 5.55087 -0.00239436 4.99926 2.40651e-05H0V4.99415H3.07455L9.27363 28.1169C9.42011 28.6617 9.74691 29.1409 10.2008 29.4764C10.6547 29.8119 11.2089 29.9841 11.7733 29.9648H37.4945C38.1574 29.9648 38.7932 30.2279 39.262 30.6961C39.7307 31.1644 39.9941 31.7996 39.9941 32.4618C39.9941 33.1241 39.7307 33.7592 39.262 34.2275C38.7932 34.6958 38.1574 34.9589 37.4945 34.9589H4.99926C4.33632 34.9589 3.70053 35.222 3.23176 35.6903C2.76298 36.1586 2.49963 36.7937 2.49963 37.456C2.49963 38.1182 2.76298 38.7534 3.23176 39.2216C3.70053 39.6899 4.33632 39.953 4.99926 39.953H7.94883C7.53772 41.0845 7.40562 42.2983 7.56371 43.4916C7.72179 44.6849 8.16541 45.8226 8.85699 46.8083C9.54857 47.7941 10.4677 48.5988 11.5367 49.1544C12.6056 49.7099 13.7928 50 14.9978 50C16.2027 50 17.39 49.7099 18.4589 49.1544C19.5278 48.5988 20.447 47.7941 21.1386 46.8083C21.8302 45.8226 22.2738 44.6849 22.4319 43.4916C22.5899 42.2983 22.4578 41.0845 22.0467 39.953H27.9459C27.5716 40.9833 27.4283 42.0831 27.5259 43.1748C27.6235 44.2665 27.9598 45.3234 28.5109 46.2712C29.062 47.2189 29.8146 48.0342 30.7156 48.6597C31.6165 49.2852 32.6439 49.7056 33.7252 49.8912C34.8065 50.0768 35.9154 50.0231 36.9737 49.7339C38.032 49.4447 39.0138 48.9271 39.85 48.2175C40.6862 47.5079 41.3563 46.6236 41.8131 45.6271C42.2699 44.6306 42.5022 43.5461 42.4937 42.4501C42.4891 41.16 42.1442 39.8939 41.4939 38.7794C42.5628 38.1062 43.444 37.1741 44.0558 36.0696C44.6676 34.9651 44.9901 33.7241 44.9934 32.4618ZM35.2198 24.9706H13.748L9.59858 9.98827H39.2442L35.2198 24.9706ZM14.9978 44.9471C14.5034 44.9471 14.0201 44.8007 13.6091 44.5263C13.198 44.2519 12.8776 43.8619 12.6884 43.4057C12.4992 42.9494 12.4497 42.4473 12.5462 41.9629C12.6426 41.4785 12.8807 41.0336 13.2303 40.6844C13.5799 40.3352 14.0252 40.0973 14.5101 40.001C14.995 39.9046 15.4976 39.9541 15.9544 40.1431C16.4111 40.3321 16.8015 40.6521 17.0762 41.0628C17.3508 41.4734 17.4974 41.9562 17.4974 42.4501C17.4974 43.1123 17.2341 43.7475 16.7653 44.2158C16.2965 44.6841 15.6607 44.9471 14.9978 44.9471ZM34.9948 44.9471C34.5004 44.9471 34.0172 44.8007 33.6061 44.5263C33.195 44.2519 32.8747 43.8619 32.6855 43.4057C32.4963 42.9494 32.4468 42.4473 32.5432 41.9629C32.6397 41.4785 32.8777 41.0336 33.2273 40.6844C33.5769 40.3352 34.0223 40.0973 34.5072 40.001C34.9921 39.9046 35.4946 39.9541 35.9514 40.1431C36.4081 40.3321 36.7985 40.6521 37.0732 41.0628C37.3479 41.4734 37.4945 41.9562 37.4945 42.4501C37.4945 43.1123 37.2311 43.7475 36.7623 44.2158C36.2936 44.6841 35.6578 44.9471 34.9948 44.9471Z" fill="#131C46" /></svg>Carrinho</h2>
                                        </div>
                                        <div className='barraDePesquisa-e-produto-carrinho-container'>
                                            <div className='barraDePesquisa-produtos-carrinho'>
                                                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z"
                                                        stroke="#131C46" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <input
                                                    type='text'
                                                    placeholder='Buscar no carrinho pelo: Nome'
                                                    value={pesquisaProdutosCarrinho}
                                                    onChange={(e) => setPesquisaProdutosCarrinho(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='conteudo-carrinho'>
                                            {produtosCarrinhoFiltrados.length === 0 ? (
                                                <p className='nenhum-produto'>Nenhum item encontrado =(</p>
                                            ) : (
                                                <>
                                                    {produtosCarrinhoFiltrados.map((item) => (
                                                        <div key={item.id_variacao} className="item-carrinho">
                                                            <div className='micro-descricao' onClick={() => setProdutoDetalhe(item)} style={{cursor: 'pointer'}}>
                                                                <div className='imagem-produto'>
                                                                    {item.imagem ? (
                                                                        <img src={item.imagem} alt={item.nome_produto} className='produto-imagem' />
                                                                    ) : (
                                                                        <div className='produto-sem-imagem'>Sem Imagem</div>
                                                                    )}
                                                                </div>
                                                                <div className='detalhes-produtos'>
                                                                    <h3 className='produto-nome'>
                                                                        {item.nome_produto}
                                                                    </h3>
                                                                    {item.nome && <p style={{opacity: 0.6, fontSize: '0.85em', margin: '2px 0', fontWeight: 500}}>{item.nome}</p>}
                                                                    {item.unidades_por_pacote > 1 ? (
                                                                        <>
                                                                            <p className='produto-preco'><strong>Unit.:</strong> {item.unidades_por_pacote} | <strong>Preço:</strong> R$ {(item.preco)} | <strong>Preço/Un.:</strong> {formatarPrecoUnitario(item.preco, item.unidades_por_pacote)} | <strong>Total:</strong> R$ {(item.preco * item.quantidade).toFixed(2)}</p>
                                                                        </>
                                                                    ) : (
                                                                        <p className='produto-preco'><strong>Preço:</strong> R$ {(item.preco)} | <strong>Total:</strong> R$ {(item.preco * item.quantidade).toFixed(2)}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                                <div className='bnt-carrinho-produto'>
                                                                    <button className='bnt-mais' onClick={() => alterarQuantidade(item.id_variacao, 1)}><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /></svg></button>
                                                                    <div className='input-qtd'>
                                                                        <input className='qtd-prod' type='number' value={item.quantidade} onChange={(e) => alterarQuantidadeDireto(item.id_variacao, e.target.value)} />
                                                                    </div>
                                                                    <button className='bnt-menos' onClick={() => alterarQuantidade(item.id_variacao, -1)}><svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.38932 0H5.34766H11.3893C11.6656 0 11.9305 0.109747 12.1259 0.305097C12.3212 0.500447 12.431 0.765399 12.431 1.04167C12.431 1.31793 12.3212 1.58289 12.1259 1.77824C11.9305 1.97359 11.6656 2.08333 11.3893 2.08333H7.43099H1.38932C1.11306 2.08333 0.848104 1.97359 0.652753 1.77824C0.457403 1.58289 0.347656 1.31793 0.347656 1.04167C0.347656 0.765399 0.457403 0.500447 0.652753 0.305097C0.848104 0.109747 1.11306 0 1.38932 0Z" fill="white" /></svg></button>
                                                                </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="total-carrinho">
                                        <p className='carrinho-qtd'>
                                            <strong>Qtd. de itens:</strong> {carrinho.length}
                                        </p>
                                        <p className='carrinho-total'>
                                            <strong>Sub-Total:</strong> R$ {carrinho.reduce((acc, item) => acc + item.preco * item.quantidade, 0).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                        {!mostrarLista && (
                        <div className='dados-pagamento'>
                            <div className='cabecalho-pagamento'>
                                <h2>Forma de Pagamento</h2>
                            </div>
                            <div className='conteudo-pagamento'>
                                <div className='metodo-e-status-container'>
                                    <div className='linha1'>
                                        <div className='dado'>
                                            <strong>Método de Pagamento</strong>
                                            <div className='selecionar-metodo-pagamento'>
                                                <select
                                                    id='metodo'
                                                    value={metodoPagamento}
                                                    onChange={(e) => setMetodoPagamento(e.target.value)}
                                                >
                                                    <option value=''>Selecione</option>
                                                    <option value='Cartão de Crédito'>Cartão de Crédito</option>
                                                    <option value='Boleto'>Boleto</option>
                                                    <option value='Transferência Bancária'>Transferência Bancária</option>
                                                    <option value='Pix'>Pix</option>
                                                    <option value='Dinheiro'>Dinheiro</option>
                                                    <option value='Cheque'>Cheque</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='dado'>
                                            <strong>Status do Pagamento</strong>
                                            <div className='selecionar-status-pagamento'>
                                                <select
                                                    id='status'
                                                    value={statusPagamento}
                                                    onChange={(e) => setStatusPagamento(e.target.value)}
                                                >
                                                    <option value='Pendente'>Pendente</option>
                                                    <option value='Pago'>Pago</option>
                                                    <option value='Falhou'>Falhou</option>
                                                    <option value='Cancelado'>Cancelado</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='linha2'>
                                        <div className='dado'>
                                            <strong>Data do Pagamento</strong>
                                            <div className='data-pagamento-container'>
                                                <input
                                                    type='date'
                                                    id='dataPagamento'
                                                    value={dataPagamento}
                                                    onChange={(e) => setDataPagamento(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='dado'>
                                            <strong>Desconto</strong>
                                            <div className='desconto'>
                                                <CurrencyInput
                                                    prefix="R$ "
                                                    decimalSeparator=","
                                                    groupSeparator="."
                                                    decimalsLimit={2}
                                                    allowNegativeValue={false}
                                                    placeholder="R$ 0,00"
                                                    value={desconto}
                                                    onValueChange={(e) => setDesconto(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                        {!mostrarLista && (
                        <div className='dados-observacoes'>
                            <div className='cabecalho-observacoes'>
                                <h2>Observações</h2>
                            </div>
                            <div className='conteudo-observacoes'>
                                <div className='obsevacao-input'>
                                    <textarea
                                        value={observacao}
                                        onChange={(e) => setObservacao(e.target.value)}
                                        maxLength={255}
                                        placeholder="Digite uma observação sobre o pedido (Opcional)"
                                    />
                                </div>
                            </div>
                        </div>
                        )}

                    </div>


                    <div className='bnt-opcoesPedido'>
                        <button className='bnt-editarPedido' onClick={() => salvar()}>
                            Editar Pedido
                        </button>
                    </div>
                    </>
                    )}
                </section>
            </main >

            <Rodape />

            {produtoDetalhe && (
                <ModalDetalheProduto
                    produto={produtoDetalhe}
                    onClose={() => setProdutoDetalhe(null)}
                    nivel={nivel}
                />
            )}
        </section >
    );
}